import { type FormValidateInput } from '@mantine/form';
import { type PayoutAdminTraderV1ActivateTraderRequest } from '~/generated/payoutBackend/model';
import { traderNameErrorText, traderNameRegex } from '../constants';

const isValidNumber = (value: string | undefined): boolean => {
    if (!value || value.trim() === '') {
        return false;
    }

    const num = parseFloat(value);

    return !isNaN(num) && isFinite(num);
};

const isValidPositiveNumber = (value: string | undefined): boolean => {
    return isValidNumber(value) && parseFloat(value!) >= 0;
};

const isValidNonNegativeInteger = (value: string | undefined): boolean => {
    if (!value || value.trim() === '') {
        return false;
    }

    const num = parseInt(value, 10);

    return !isNaN(num) && isFinite(num) && num >= 0 && String(num) === value.trim();
};

export const validate: FormValidateInput<PayoutAdminTraderV1ActivateTraderRequest> = {
    traderName: {
        value: (value) => {
            if (!value?.trim()) {
                return 'Обязательное поле';
            }

            return traderNameRegex.test(value) ? null : traderNameErrorText;
        },
    },
    commission: {
        value: (value) => {
            const val = String(value);

            if (val.trim() === '') {
                return 'Обязательное поле';
            }

            if (!isValidPositiveNumber(val)) {
                return 'Должно быть неотрицательным числом';
            }

            return null;
        },
    },

    // Calculation Rules - строка
    calculationRules: (value) => {
        if (value && value.length > 500) {
            return 'Максимум 500 символов';
        }

        return null;
    },

    // Config - валидация вложенных полей
    config: {
        limit: {
            value: (value) => {
                const val = String(value);

                if (value && val.trim() !== '' && !isValidPositiveNumber(val)) {
                    return 'Лимит должен быть неотрицательным числом';
                }

                return null;
            },
        },
        paymentChannels: (channels) => {
            if (channels && channels.length > 0) {
                for (let i = 0; i < channels.length; i++) {
                    const ch = channels[i];
                    const prefix = `Канал ${i + 1}`;

                    const min = String(ch.filter?.amount?.min?.value);
                    const max = String(ch.filter?.amount?.max?.value);

                    if (min && min.trim() !== '' && !isValidPositiveNumber(min)) {
                        return `${prefix}: мин. сумма должна быть числом`;
                    }

                    if (max && max.trim() !== '' && !isValidPositiveNumber(max)) {
                        return `${prefix}: макс. сумма должна быть числом`;
                    }

                    if (
                        min &&
                        max &&
                        min.trim() !== '' &&
                        max.trim() !== '' &&
                        isValidNumber(min) &&
                        isValidNumber(max) &&
                        parseFloat(min) > parseFloat(max)
                    ) {
                        return `${prefix}: мин. не может быть больше макс.`;
                    }

                    const queue = String(ch.config?.maxQueueLength);

                    if (queue && queue.trim() !== '' && !isValidNonNegativeInteger(queue)) {
                        return `${prefix}: длина очереди должна быть целым числом`;
                    }
                }
            }

            return null;
        },
    },
};
